import React, { ReactElement } from 'react';
import { FooterContainer as Footer } from '@lerna-core';
import { FooterContainerProps } from './footer.model';

export const FooterContainer = ({
  footerImages,
}: FooterContainerProps): ReactElement => (
  <Footer footerImages={footerImages} />
);
